// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Graficos_PegagraficocategoriasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Graficos_PegagraficocategoriasResponseDados {
categoria: string[]
valor_categoria: number[]
}

export type Graficos_PegagraficocategoriasResponse = ApiResponse<Graficos_PegagraficocategoriasResponseDados>;

registerResponseContract('Graficos_PegagraficocategoriasResponse', {
  categoria:       { type: 'array',   required: true },
  valor_categoria: { type: 'array',   required: true },
})
